module.exports = __webpack_public_path__ + "img/12217_16.bbec71a0.png";